/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBadge5S = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11.305 2.281a1 1 0 0 1 1.39 0l1.874 1.813 2.581-.365a1 1 0 0 1 1.125.817l.45 2.568 2.303 1.221a1 1 0 0 1 .43 1.323L20.313 12l1.145 2.342a1 1 0 0 1-.43 1.323l-2.302 1.221-.45 2.568a1 1 0 0 1-1.126.817l-2.581-.365-1.874 1.813a1 1 0 0 1-1.39 0L9.43 19.906l-2.58.365a1 1 0 0 1-1.126-.817l-.45-2.568-2.303-1.222a1 1 0 0 1-.43-1.322L3.687 12 2.542 9.658a1 1 0 0 1 .43-1.323l2.303-1.221.45-2.568A1 1 0 0 1 6.85 3.73l2.581.365zM9.658 13.85v1.33c.267.14.587.25.96.33.38.08.777.12 1.19.12.54 0 1.01-.1 1.41-.3.407-.2.72-.48.94-.84.22-.367.33-.793.33-1.28 0-.693-.213-1.237-.64-1.63-.427-.4-1.01-.6-1.75-.6-.353 0-.7.06-1.04.18l.18-1.56h2.83V8.33h-3.95l-.42 3.42.88.69c.453-.2.897-.3 1.33-.3.373 0 .66.093.86.28.207.187.31.447.31.78 0 .347-.123.62-.37.82s-.583.3-1.01.3a4.584 4.584 0 0 1-2.04-.47z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBadge5S as Badge5S };
